import AddCardHeader from 'components/HappeningNonContent/ServiceBooking/ReviewAndPay/PaymentInfo/AddCardHeader/AddCardHeader';

export default AddCardHeader;
